import { STATUS } from "../../../../constants/server/api";
import { employeeHandler } from "../../../../redux/handlers";

export const SubmitChangeEmail = async (dispatch, empID, values) => {
  try {
    const result = await dispatch(
      employeeHandler.updateEmployeeEmail(empID, values)
    );
    if (result == STATUS.OK) {
      return true;
    }
    return false;
  } catch (error) {
    console.log(error);
    return false;
  }
};
